module.exports = __webpack_public_path__ + "img/ic-lee.c64d85f3.jpg";